import React from 'react';
import { Pagination } from 'antd';

const Paginator = ({ currentPage, totalItems, pageSize, onPageChange }) => {
    return (
    <Pagination
      current={currentPage}
      total={totalItems}
      pageSize={pageSize}
      onChange={onPageChange}
      showSizeChanger={false}
      
    />
  );
};

export default Paginator;
